/* External */
import defaultsDeep from 'lodash-es/defaultsDeep';

/* Utils */
import defaultUtils from './default';
import webOSUtils from './webOS';
import tizenUtils from './tizen';
import hisenseUtils from './hisense';
import zeasnUtils from './zeasn';
import firetvutils from './fireTV';
import titanUtils from './titan';
import { Platform } from '../constants';

const PlatformApi = {
  [Platform.WEBOS]: webOSUtils,
  [Platform.TIZEN]: tizenUtils,
  [Platform.HISENSE]: hisenseUtils,
  [Platform.TITAN]: titanUtils,
  [Platform.ZEASN]: zeasnUtils,
  [Platform.DEFAULT]: defaultUtils,
  [Platform.FIRETV]: firetvutils,
};

let platform;

export function getPlatform() {
  return platform || Object.keys(PlatformApi)
    .find((searchingPlatform) => PlatformApi[searchingPlatform].isThisPlatform())
    || Platform.DEFAULT;
}

export function isDefaultPlatform() {
  return getPlatform() === Platform.DEFAULT;
}

export default defaultsDeep({}, PlatformApi[getPlatform()], defaultUtils);
